<script>
    import SubscriptionForm from "./subscriptionform.svelte";
    import Card from "../components/card.svelte";
    import Router from '../../router'

    let exportdeactivestatus = false;
    $: if (exportdeactivestatus.status) {
        //jQuery('.nav-tabs a[href="#sub3"]').tab('show');
        //ShowDeactive = true;
    }
     
    let exportrenewalstatus = [];
    $: if (exportrenewalstatus.status) { 
        //jQuery('.nav-tabs a[href="#sub3"]').tab('show');
        //ShowRenewal = true;
    }

    let exportarchived = false;
    $: if (exportarchived) {
        window.location.href = '/app/subscriptions';
    }

    let ShowSubscription = false;
    let ShowPending = true;
    let ShowDelete = false;
    
    let pageTitle = "Subscriptions | Wavenet Nimbus";
</script>

<svelte:head>
<title>{pageTitle}</title>
</svelte:head>

<div>
    <a class="btn btn-grey mb-3" href="/app/subscriptions"><i
            class="fas fa-backward" />
        Back</a>
</div>

<h1>New Subscription</h1>

<Card>
    <div slot="body">
        <SubscriptionForm {pageTitle} {ShowSubscription} {ShowPending} {ShowDelete} 
        bind:exportrenewalstatus={exportrenewalstatus} bind:exportdeactivestatus={exportdeactivestatus} bind:exportarchived={exportarchived}
        on:added={(e)=> Router.route(`/app/subscriptions/${e.detail}/permissions`)}></SubscriptionForm>
    </div>
</Card>